export default table => {
    const exportAsXlsx = {
        key: 'export-as-xlsx',
        label: '导出为Excel',
        onClick: () => table.exportAsXlsx(),
    }

    const exportAsCsv = {
        key: 'export-as-csv',
        label: '导出为CSV',
        onClick: () => table.exportAsCsv(),
    }

    return {
        key: 'export',
        label: '导出',
        children: [exportAsXlsx, exportAsCsv],
    }
}
